import React, { useState } from "react";
import posthog from "posthog-js";
import { BUTTONTYPES } from "../../constants/GeneralConstants";
import { Button } from "../button/Button";
import s from "./CookieBanner.module.scss";
import { Link } from "react-router-dom";

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(true);

  const handleAccept = () => {
    posthog.opt_in_capturing();
    setShowBanner(false);
  };

  const handleDecline = () => {
    posthog.opt_out_capturing();
    setShowBanner(false);
  };

  return (
    <>
      {showBanner && (
        <div className={s.bannerContainer}>
          <div className={s.bannerText}>
            Šajā vietnē tiek izmantotas sīkdatnes, lai nodrošinātu jums labāku
            pārlūkošanas pieredzi mūsu vietnē. Turpinot vietnes pārlūkošanu, jūs
            piekrītat mūsu{" "}
            <Link to='/privatuma-politika'>privātuma politikai</Link>.{" "}
          </div>
          <div className={s.buttonContainer}>
            <Button
              text={"Piekrītu"}
              type={BUTTONTYPES.primary}
              buttonColor={"#299929"}
              onClick={handleAccept}
              fontSize='16px'
              width='160px'
            />
            <Button
              text={"Piekrītu tikai nepieciešamām"}
              type={BUTTONTYPES.secondary}
              buttonColor={"#299929"}
              onClick={handleDecline}
              fontSize='12px'
              width='160px'
            />
          </div>
        </div>
      )}
    </>
  );
};

export default CookieBanner;
